// import './SignIn.less';

export const prefix = 'bm-c-sign-in';

export { default } from './SignIn';
